import { useEnvStore } from '@/store/env.store';
import { useStatisticsListStore } from '@/store/statistics/statistics-list.store';
import { storeToRefs } from 'pinia';
import { defineComponent, onMounted } from 'vue';
import { STATISTICS_LIST_COLUMN_LIST } from '@/constants/statistics/statistics-list-column-list.constant';
import { STATISTICS_LIST_HINT_MAP } from '@/constants/statistics/statistics-list-hint-map.constant';
import HintComponent from '@/components/hint/hint';
import { StatisticsListItem } from '@/models/statistics/statistics-list.model';
import { StatisticsListSectionNames } from '@/models/statistics/statistics-list-section-names.model';
import StatisticsListFilter from '@/layouts/statistics/statistics-list/statistics-list-filter/statistics-list-filter';
import { useStatisticsListFilterStore } from '@/store/statistics/statistics-list-filter.store';

export default defineComponent({
  name: 'StatisticsList',
  components: {
    HintComponent,
    StatisticsListFilter,
  },
  setup() {
    const statisticsListStore = useStatisticsListStore();
    const { getStatisticsList } = statisticsListStore;
    const { isStatisticsListLoading, statisticsList } = storeToRefs(statisticsListStore);
    const { WL_SLUG } = storeToRefs(useEnvStore());

    const statisticsListFilterStore = useStatisticsListFilterStore();
    const { statisticsFilterFormData } = storeToRefs(statisticsListFilterStore);

    const getRowClassName = ({ row }: { row: StatisticsListItem }): string =>
      row.section === StatisticsListSectionNames.TOTAL
        ? 'statistics-list__row_success statistics-list__row_font-weight-bold'
        : 'statistics-list__row_font-weight-bold';

    onMounted(() => {
      getStatisticsList(WL_SLUG.value, statisticsFilterFormData.value);
    });

    return {
      isStatisticsListLoading,
      statisticsList,
      STATISTICS_LIST_COLUMN_LIST,
      STATISTICS_LIST_HINT_MAP,
      getRowClassName,
    };
  },
});
